
import { Component } from "vue-property-decorator";
import { Action } from "vuex-class";
import { SIGN_OUT } from "../store/action-types";
import BaseView from "./BaseView";

@Component
export default class SignOutView extends BaseView {
  @Action(`auth/${SIGN_OUT}`) signOut: () => void;

  async mounted() {
    await this.signOut();
    this.$router.replace("sign-in");
  }
}
